export function shop_brand_info() {
    $(this).addClass('hoverintent');
}
